import React from "react";
import {
  FormInput as BaseFormInput,
  FormSelect as BaseFormSelect,
  SearchableSelect as BaseSearchableSelect,
  FormTextarea as BaseFormTextarea,
} from "../../../../components/ui";

const labelClass = "text-slate-700 font-bold text-[12px] tracking-wide uppercase";
const inputClass = "text-[12px] font-medium text-slate-800 bg-white border-slate-200 focus:border-slate-800 transition-all h-[36px] shadow-sm rounded-md";

export const FormInput = (props) => <BaseFormInput {...props} labelClassName={labelClass} inputClassName={inputClass} />;
export const FormSelect = (props) => <BaseFormSelect {...props} labelClassName={labelClass} inputClassName={inputClass} />;
export const FormTextarea = (props) => <BaseFormTextarea {...props} labelClassName={labelClass} inputClassName={inputClass} />;
export const SearchableSelect = (props) => <BaseFormSelect {...props} labelClassName={labelClass} inputClassName={inputClass} />;
